import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTable from "@toothfairy/shared-ui/AppTable";
import AppToast from "@toothfairy/shared-ui/AppToast";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import React from "react";
import { useTranslation } from "react-i18next";

const SiteTokenComponent = ({ values, wrapperStyle }) => {
  const { t } = useTranslation();
  const AppToasty = AppToast.useToast();
  const { state } = AppStateManager.useAppStateManager();
  return (
    <AppTable
      customEditIcon={AppAssets?.icons?.quickCopy}
      handleDocumentDeletion={null}
      actionButtons
      showDropDownMenuForActions={false}
      mainActionLabel={t("settings.list.copy")}
      handleDocumentSelection={() => {
        navigator.clipboard.writeText(
          state?.sites?.find((u) => u?.id === values?.id)?.validationToken,
        );
        AppToasty.show(t("settings.sites.copied"), {
          type: "success",
        });
      }}
      style={[
        {
          zIndex: -1,
          height: 210,
          paddingRight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        },
        wrapperStyle,
      ]}
      headers={[
        {
          title: t("settings.list.type"),
          width: 0.1,
        },
        {
          title: t("settings.list.dnsRecord"),
          width: 0.8,
        },
        {
          title: " ",
          width: 0.1,
        },
      ]}
      items={[
        {
          key: t("settings.list.hostname"),
          value: "toothfairyai._domainkey",
          action: " ",
        },
        {
          key: t("settings.list.type"),
          value: "TXT",
          action: " ",
        },
        {
          key: t("settings.list.value"),
          value:
            state?.sites?.find((u) => u?.id === values?.id)?.validationToken ||
            "",
          action: " ",
        },
      ]}
    />
  );
};

export default SiteTokenComponent;
